module.exports = __webpack_public_path__ + "img/9788992263177.b21e5492.jpg";